import { useContext, useMemo } from "react";
import UserContext, { User_Type } from "./UserContext";

interface Props {
    children: any;
    opName?: string;
    fallback?: JSX.Element | null;
}

export default function Authorize({
    children,
    opName,
    fallback = null,
}: Props) {
    const { user } = useContext(UserContext);

    const permissions = useMemo(() => {
        if (!user) return [];

        if (user.user_type === User_Type.Superadmin) return [];

        return user.role.permissions.map((item) => item.op.name);
    }, [user?.user_type]);

    if (permissions && opName && permissions.includes(opName)) return children;
    else if (!opName) return children;
    else return fallback;
}
